// extracted by mini-css-extract-plugin
export var indeterminate = "_54-5";
export var md = "_54-4";
export var semantic = "_54-6";
export var sm = "_54-3";
export var text = "_54-7";
export var toggleInput = "_54-0";
export var toggleSwitch = "_54-1";
export var xs = "_54-2";